export class Type {
  id: number;
  title: string;
  createdAt: string;
  updatedAt: string;
  constructor() {
    this.id = null;
    this.title = '';
    this.createdAt = '';
    this.updatedAt = '';
  }
}
